/**
 * @utility-ng-time
 */

module.exports = 'utility-ng-enumeration';
var TimeUtility = require('utility-js-time');

angular
  .module('utility-ng-time', [])
  .constant('TimeUtility', TimeUtility.TimeUtility)
  .constant('DayOfTheWeekEnum', TimeUtility.DayOfTheWeekEnum)
  .constant('TimeWindowEnum', TimeUtility.TimeWindowEnum);

require('./builders/date_range_builder');



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-time/src/main.js